<script setup lang="ts">

import VFieldLabel from "@/components/forms/VFieldLabel.vue";
import {computed, ref} from "vue";

interface Props {
    description: string | null
    hidden?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    hidden: false,
})

const emit = defineEmits<{ submit: [comment: string|null] }>();

const comment = ref<string | null>(props.description);

const isDisabled = computed(() => {
    return comment.value === props.description || (comment.value === null || comment.value.trim() === '');
})
</script>

<template>
    <div v-if="!props.hidden">
        <v-field-label>
            Write a comment to provide additional context or information
        </v-field-label>
        <v-textarea
            v-model="comment"
            density="compact"
            name="comment"
            rows="1"
            hide-details
            auto-grow
        >
            <template #append-inner>
                <v-btn
                    color="primary"
                    size="small"
                    :disabled="isDisabled"
                    @click="emit('submit', comment)"
                >
                    Save
                </v-btn>
            </template>
        </v-textarea>
    </div>
</template>

<style scoped>

</style>
